export enum TournamentStatsEnum {
  Goals = "goal",
  Assists = "assist",
  RedCards = "redCards",
  YellowCards = "yellowCards",
}
